import { StringUtils } from ".";

interface ISessionStore {
    set(key: string, data: any): ISessionStore;
    get<T>(key: string, defaultValue?: T): T | null;
    remove(key: string): ISessionStore;
}

export const SessionStore: ISessionStore = {
    set(key: string, data: any): ISessionStore {
        try {
            sessionStorage.setItem(key, StringUtils.stringify(data));
        } catch (error) {}
        return this;
    },
    get<T>(key: string, defaultValue?: T): T | null {
        try {
            const value = sessionStorage.getItem(key);
            if (!value) {
                return defaultValue || null;
            }
            const data = StringUtils.parse<T>(value);
            return data;
        } catch (error) {
            return null;
        }
    },
    remove(key: string): ISessionStore {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {}
        return this;
    },
};

export default SessionStore;
